// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"7ecd06a8","458":"ce9da948","519":"34b1169d","774":"92e72498","820":"b473684d","851":"f7edc491","858":"26f30a2c"}[chunkId] + ".chunk.js";
};